import React, { useState } from 'react';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import CustomTextField from '../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import '../activity-calendar.scss';
import ImageUpload from '../../../../shared/image-upload/ImageUpload';

const Banner = ({ initialValue, handleOnChange }) => {
  const [status, setSatus] = useState(false);
  const [rawImages, setRawImages] = useState([]);

  const onImageListUpdated = (imgObjArr) => {
    const createImageArray = [];
    imgObjArr?.forEach((img, index) => {
      if (img?.master || img?.isTouched) {
        createImageArray?.push(img);
      } else {
        let currentImg = initialValue?.bannerImage?.value[index];
        createImageArray?.push(currentImg);
      }
    });

    if (imgObjArr?.length) {
      const lastImg = createImageArray[createImageArray?.length - 1];
      setRawImages([lastImg]);
      handleOnChange({
        bannerImage: {
          ...initialValue?.bannerImage,
          value: [lastImg],
        },
      });
    } else if (rawImages?.length) {
      handleOnChange({
        bannerImage: {
          ...initialValue?.bannerImage,
          value: [],
        },
      });
      setRawImages([]);
    }
  };

  const onUploadedImageRemoval = () => {
    setRawImages([]);
    handleOnChange({
      bannerImage: {
        ...initialValue.bannerImage,
        value: [],
      },
    });
  };

  const handleBannerStatusChange = (e) => {
    const isActive = e.target.value === 'active';
    handleOnChange({
      bannerStatus: {
        ...initialValue.bannerStatus,
        value: isActive,
      },
      ...(!isActive && {
        bannerImage: {
          ...initialValue.bannerImage,
          value: [],
        },
        bannerIsActive: {
          ...initialValue.bannerIsActive,
          value: 'colorCode',
        },
        bannerColor: {
          ...initialValue.bannerColor,
          value: '#ffffff',
        },
      }),
    });
    if (!isActive) {
      setRawImages([]);
    }
  };

  return (
    <div className='row px-3 w-100 d-flex mt-4 form-scroll'>
      <div className='row'>
        <div className='col-md-12 mt-2'>
          <RadioGroup
            row
            aria-label='bannerStatus'
            name='bannerStatus'
            onChange={handleBannerStatusChange}
            value={initialValue?.bannerStatus?.value ? 'active' : 'inactive'}
            className='document-type mb-3'
          >
            <FormControlLabel
              value='active'
              control={<Radio color='primary' />}
              label='Active'
              className='form-control-spacing right-margin'
            />
            <FormControlLabel
              value='inactive'
              control={<Radio color='primary' />}
              label='Inactive'
              className='form-control-spacing left-margin'
            />
          </RadioGroup>
        </div>

        {initialValue?.bannerStatus?.value && (
          <>
            <h5 className='tab-title'>Type</h5>
            <div className='col-md-12 mt-2'>
              <RadioGroup
                row
                aria-label={'bannerIsActive'}
                onChange={(e) => {
                  handleOnChange({
                    bannerIsActive: {
                      ...initialValue.bannerIsActive,
                      value: e.target.value,
                    },
                  });
                }}
                value={initialValue?.bannerIsActive?.value}
                name={'bannerIsActive'}
                className='document-type mb-3'
              >
                <FormControlLabel
                  value='colorCode'
                  control={<Radio color='primary' />}
                  label='Label'
                  className='form-control-spacing right-margin'
                />
                <FormControlLabel
                  value='image'
                  control={<Radio color='primary' />}
                  className='form-control-spacing type-image'
                  label='Image'
                />
              </RadioGroup>
            </div>

            {initialValue?.bannerIsActive?.value === 'colorCode' ? (
              <>
                <div className='col-md-6 mb-3 '>
                  <CustomTextField
                    item={initialValue?.bannerColor}
                    handleInputChange={(values) => {
                      handleOnChange({ bannerColor: values });
                    }}
                    endAdornment={true}
                    maxLength={8}
                    type={'color'}
                  />
                </div>
                <div className='col-md-3 position-absolute end-0'>
                  <div className='color-preview-text'>Preview</div>
                  <div
                    className='color-preview-section'
                    style={{ backgroundColor: initialValue.bannerColor.value }}
                  ></div>
                </div>
              </>
            ) : (
              <ImageUpload
                uploadedImages={initialValue?.bannerImage?.value}
                imgList={rawImages}
                onImageListUpdated={onImageListUpdated}
                onUploadedImageRemoval={onUploadedImageRemoval}
                onImagesLoading={(status) => {
                  setSatus(status);
                }}
                isActivityBanner={true}
                enabledMediaTabs={['image']}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Banner;
